/**
 * ListCategory
 */

import DropdownLayer from '../DropdownLayer';
import Config from '../Config';
import Util from '../Util';
import Template from './Template';
import UIKIT from 'uikit-utils';

class ListShare {

	private $node: any;

	private options: any;

	private dropdownLayer: any;

	private share: any;

	constructor( $node: any, options: any ) {
		this.$node = $node;
		this.options = options;
		this.share = new UIKIT.Share();
		this.init();
	}

	public setValue( val: string ) {
		this.dropdownLayer.setValue( val );
	}

	private addEvent() {
		jQuery('body').on('click','.co-btn-share', (evt) => {
            let obj: { title: any; location: any };
            evt.preventDefault();
            evt.stopPropagation();
            obj = {
                title: evt.currentTarget.dataset.title,
                location: evt.currentTarget.dataset.location,
            };

            this.share.resetOptions(obj);
            this.share.toggleLayer();
		});
	}

	private init() {
        this.share.init();
        this.addEvent();
	}
}

export default ListShare;
